module.exports = __webpack_public_path__ + "static/media/scheduleGray.ee9d087c.svg";